import * as React from "react";
import { themed } from "@adc/parallax-icons";
const SvgGreenEllipsis = themed((props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 19 18", ...props }, /* @__PURE__ */ React.createElement("circle", { cx: 9.5, cy: 9, r: 6, fill: "#7CCC6C" })));
export default SvgGreenEllipsis;
